import Resource from './Resource'

class TextTemplateService extends Resource {
    async findAllIndexTemplates(laboratoryId) {
        const response = await this.axios.get(`laboratories/${laboratoryId}/textTemplates`)
        return response.data
    }

    async findCompatibleIndexTemplates(laboratoryId, caseId, sampleId) {
        const response = await this.axios.get(`laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/textTemplates/compatible`)
        return response.data
    }

    async findTemplateById(templateId) {
        const response = await this.axios.get(`textTemplates/${templateId}`)
        return response.data
    }
}

export default new TextTemplateService()
